var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-mobile"},[_c('div',{staticClass:"bar-container-mobile"},[_c('progress-bar',{style:(_vm.cssVars),attrs:{"bar-color":"#AF00B1","val":_vm.percentage,"text":_vm.percentage+'%'}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }